import SimpleDialog from '@fuse/core/SimpleDialog';
import {
  Avatar,
  Button,
  Card,
  CardContent,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import BirthdayUzinfocomDialog from 'app/shared-components/BirthdayUzinfocom_23/BirthdayDialog';
import StaffContactDetails from 'app/shared-components/StaffContactDetails';
import HappyBirthdayDialog from 'app/shared-components/happyBirthdayDialog/HappyBirthdayDialog';
import {
  getEmployeesTodayBirthdays,
  getEmployeesUpcomingBirthdays,
  selectAreBirthdaysLoading,
  selectEmployeesTodayBirthdays,
  selectEmployeesUpcomingBirthdays,
  selectTopsTodayBirthdays,
  selectTopsUpcomingBirthdays,
} from 'app/store/birthdaysSlice';
import { motion } from 'framer-motion';
import _ from 'lodash';
import moment from 'moment';
import { useEffect, useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { capitalizeFirstLetter, getAbsoluteFileUrl } from 'src/app/helpers/utils';
import { useUser } from 'src/app/hooks/useUser';
import TopsBirthdayList from './TopsBirthdayList';
import { useThemeMediaQuery } from '@fuse/hooks';

const BirthdayList = () => {
  const { t } = useTranslation('translations');
  const isMobile = useThemeMediaQuery((theme) => theme.breakpoints.down('md'));
  const [isToday, setIsToday] = useState(
    () => localStorage.getItem('isNewsBirthdayVisible') === 'false' || isMobile
  );
  const { user } = useUser();
  const [isEmplDetailsOpen, setIsEmplDetailsOpen] = useState(false);
  const [activeEmplId, setActiveEmplId] = useState(null);
  const [isHappyBirthdayVisible, setIsHappyBirthdayVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [resizeViewport, setResizeViewport] = useState(window.innerWidth);

  const dispatch = useDispatch();
  const employeesTodayBirthdays = useSelector(selectEmployeesTodayBirthdays);
  const employeesUpcomingBirthdays = useSelector(selectEmployeesUpcomingBirthdays);
  const topsTodayBirthdays = useSelector(selectTopsTodayBirthdays);
  const topsUpcomingBirthdays = useSelector(selectTopsUpcomingBirthdays);
  const loading = useSelector(selectAreBirthdaysLoading);

  useLayoutEffect(() => {
    const today = moment().format('YYYY-MM-DD');
    const isJuly28 = moment().format('MM-DD') === '07-29';
    const seenKey = 'uzinfocom_birthday_dialog_seen';
    const alreadySeen = sessionStorage.getItem(seenKey);

    if (isJuly28 && alreadySeen !== today) {
      setIsVisible(true);
      sessionStorage.setItem(seenKey, today);
    } else {
      setIsVisible(false);
    }
  }, []);

  useEffect(() => {
    dispatch(getEmployeesTodayBirthdays());
    dispatch(getEmployeesUpcomingBirthdays());
  }, []);

  useEffect(() => {
    const root = document.getElementById('root');

    if (isEmplDetailsOpen) {
      root?.setAttribute('inert', '');
      document.body.style.overflow = 'hidden';
    } else {
      root?.removeAttribute('inert');
      document.body.style.overflow = '';
    }

    return () => {
      root?.removeAttribute('inert');
      document.body.style.overflow = '';
    };
  }, [isEmplDetailsOpen]);

  useEffect(() => {
    window.addEventListener('resize', function () {
      setResizeViewport(window.innerWidth);
    });
  }, [resizeViewport]);

  const handleEmplClick = (id) => {
    setActiveEmplId(id);
    setIsEmplDetailsOpen(true);
  };

  useEffect(() => {
    if (employeesTodayBirthdays && employeesTodayBirthdays.length) {
      if (employeesTodayBirthdays.some((empl) => empl.id === user.staffId)) {
        setIsHappyBirthdayVisible(true);
      }
    }
  }, [employeesTodayBirthdays]);

  return (
    <>
      <Card
        component={motion.div}
        variants={{
          hidden: { opacity: 0, y: 40 },
          show: { opacity: 1, y: 0 },
        }}
        className="w-full mb-10 rounded-16 p-24 shadow-2"
      >
        <div>
          <Typography component="p" className="flex flex-1 text-2xl leading-tight">
            {t('Birthdays', "Tug'ilgan kunlari")}
          </Typography>
        </div>

        <div className="flex items-center mt-20 flex-col sm:flex-row border-[1px] p-4 rounded-md">
          <Button
            onClick={() => setIsToday(true)}
            variant="outlined"
            sx={{ border: 0 }}
            className={`w-full basis-1/2 rounded-md text-base ${
              isToday
                ? 'text-white bg-blue hover:bg-blue'
                : 'text-darkgrey bg-white dark:bg-dark hover:bg-white'
            }`}
          >
            {t('Today')}
          </Button>
          <Button
            onClick={() => setIsToday(false)}
            variant="outlined"
            sx={{ border: 0 }}
            className={`w-full basis-1/2 rounded-md text-base mt-10 sm:mt-0 ${
              isToday
                ? 'text-darkgrey bg-white dark:bg-dark hover:bg-white'
                : 'text-white bg-blue hover:bg-blue'
            }`}
          >
            {t('InFewDays')}
          </Button>
        </div>

        <CardContent className="p-0 pt-12">
          {!loading &&
            isToday &&
            employeesTodayBirthdays?.length === 0 &&
            topsTodayBirthdays?.length === 0 && (
              <div className="text-center">{t('NoTodayBirthdays')}</div>
            )}
          {!loading &&
            !isToday &&
            employeesUpcomingBirthdays?.length === 0 &&
            topsUpcomingBirthdays?.length === 0 && (
              <div className="text-center">{t('NoIncomingBirthdays')}</div>
            )}
          {Array.isArray(topsTodayBirthdays) && topsTodayBirthdays.length > 0 && (
            <TopsBirthdayList
              birthdays={isToday ? topsTodayBirthdays : topsUpcomingBirthdays}
              isToday={isToday}
            />
          )}
          <List className="p-0">
            {_.map(isToday ? employeesTodayBirthdays : employeesUpcomingBirthdays, (birthday) => (
              <ListItem
                key={birthday.id}
                className="px-0 space-x-8 cursor-pointer hover:bg-grey-50 dark:hover:bg-lightblack border-b-1"
                onClick={() => handleEmplClick(birthday.id)}
              >
                <Avatar src={getAbsoluteFileUrl(birthday?.photo)} alt={birthday.name}>
                  {birthday?.fullName?.name.slice(0, 1)}
                </Avatar>
                <ListItemText>
                  <div className="flex flex-col">
                    <Typography
                      className="font-bold text-base font-lexend dark:text-white"
                      color="primary.main"
                      paragraph={false}
                    >
                      {capitalizeFirstLetter(birthday.fullName.name)}{' '}
                      {capitalizeFirstLetter(birthday.fullName.surname)}
                    </Typography>

                    <Typography
                      className="text-sm font-normal dark:text-darkgrey"
                      paragraph={false}
                      color="primary.light"
                    >
                      {moment(birthday.birthDate).format('Do MMMM')}
                    </Typography>
                  </div>
                </ListItemText>
              </ListItem>
            ))}
          </List>
        </CardContent>
      </Card>
      <SimpleDialog open={isEmplDetailsOpen} onClose={() => setIsEmplDetailsOpen(false)} noPadding>
        <StaffContactDetails id={activeEmplId} />
      </SimpleDialog>

      <HappyBirthdayDialog
        isVisible={isHappyBirthdayVisible}
        onClose={() => setIsHappyBirthdayVisible(false)}
      />
      <BirthdayUzinfocomDialog isVisible={isVisible} setIsVisible={setIsVisible} />
    </>
  );
};

export default BirthdayList;
